import React from 'react';
import './KebabHero.css';

const KebabHero = () => {
  const FloatingElement = ({ children, delay = 0, duration = 20, startX = 0, startY = 0 }) => (
    <div
      className="floating-element"
      style={{
        left: `${startX}%`,
        top: `${startY}%`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
      }}
    >
      {children}
    </div>
  );

  const KebabSkewer = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className="text-amber-400">
      <path
        d="M2 12L22 12M4 8L20 8M4 16L20 16M3 6L21 6M3 18L21 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const SpiceParticle = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className="text-red-500">
      <circle
        cx="12"
        cy="12"
        r="3"
        fill="currentColor"
        opacity="0.7"
      />
    </svg>
  );

  return (
    <div className="kebab-hero">
      {/* Video Background */}
      <div className="video-background">
        <video 
          className="background-video"
          autoPlay 
          muted 
          loop 
          playsInline
          style={{ playbackRate: 0.5 }}
          poster="/path/to/your/poster-image.jpg"
          onLoadedData={(e) => {
            e.target.playbackRate = 1;
          }}
        >
          <source src="/video/hero_background_2.mp4" type="video/mp4" />
          <source src="/path/to/your/video.webm" type="video/webm" />
          <div className="video-placeholder">
            <div className="video-overlay"></div>
            <div className="video-gradient"></div>
          </div>
        </video>
        <div className="video-overlay"></div>
        <div className="video-gradient"></div>
      </div>

      {/* Floating Elements */}
      <FloatingElement delay={0} duration={25} startX={10} startY={100}>
        <KebabSkewer size={32} />
      </FloatingElement>
      <FloatingElement delay={5} duration={30} startX={80} startY={100}>
        <SpiceParticle size={20} />
      </FloatingElement>
      <FloatingElement delay={10} duration={28} startX={60} startY={100}>
        <KebabSkewer size={28} />
      </FloatingElement>
      <FloatingElement delay={15} duration={35} startX={30} startY={100}>
        <SpiceParticle size={16} />
      </FloatingElement>

      {/* Navigation */}
      <nav className="navigation">
        <div className="nav-logo">
          <img 
            src="/image/logo.jpg" 
            alt="Meister Döner Logo" 
            className="h-10 w-auto"
          />
          <span className="logo-text">Meister Döner</span>
        </div>
        <div className="nav-links">
          <a 
            href="#hero" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('hero')?.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
              });
            }}
          >
            Startseite
          </a>
          <a 
            href="#gallery" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('gallery')?.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
              });
            }}
          >
            Speisekarte
          </a>
          <a 
            href="#contact" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
              });
            }}
          >
            Kontakt
          </a>
          <a 
            href="#contact" 
            className="nav-link"
          >
            Allergene
          </a>
          <a 
            href="#contact" 
            className="nav-link"
          >
            FAQ
          </a>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="hero-content">
        <div className="hero-text">
          {/* Main Heading */}
          <div className="hero-heading">
            <h1 className="main-title">
              <span className="title-line">BESTER</span>
              <span className="title-line subtitle">DÖNER</span>
              <span className="title-line">AACHENS</span>
            </h1>
          </div>

          {/* Subtitle */}
          <div className="hero-subtitle">
            <p className="subtitle-text">
              Wo Tradition auf Geschmack trifft. Jeder Döner wird mit Liebe und den besten Zutaten zubereitet.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="cta-buttons">
            <button 
                className="cta-primary"
                onClick={() => {
                const target = document.querySelector('#contact');
                if (target) {
                    target.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                    });
                }
                }}
            >
                <span className="button-text">JETZT BESTELLEN</span>
                <div className="button-overlay"></div>
                <span className="button-text-hover">JETZT BESTELLEN</span>
            </button>
            
            <button 
                className="cta-secondary"
                onClick={() => {
                const target = document.querySelector('#gallery');
                if (target) {
                    target.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                    });
                }
                }}
            >
                SPEISEKARTE ANSEHEN
            </button>
            </div>
        </div>
      </div>

      {/* Side Text */}
      <div className="side-text left">
        <span>NACH UNTEN SCROLLEN</span>
      </div>

      <div className="side-text right">
        <span>FRISCH ZUBEREITET</span>
      </div>

      {/* Social Links */}
      <div className="social-links">
        <a href="https://www.instagram.com/meisterdoneraachen/" target='_blank' rel="noreferrer" className="social-link" aria-label="Instagram">
          <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
        </a>
        <a href="https://www.facebook.com/people/Meister-D%C3%B6ner/61561144980221/" target='_blank' rel="noreferrer" className="social-link" aria-label="Facebook">
          <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default KebabHero;